 export const breakpoints = {
    s: 768,
    m: 1024,
    l: 1440,
  }
